var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.SubmitPrint()
      }
    }
  }, [_vm._v("Print")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticStyle: {
      "font-size": "12px",
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "padding-bottom": "0px!important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "25%",
      "border": "none !important",
      "padding-bottom": "0px"
    }
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%",
      "border": "none !important",
      "padding-bottom": "0px"
    }
  }, [_c('label', {
    staticStyle: {
      "width": "100%",
      "text-align": "Center!important",
      "font-size": "2em !important"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.shippingcompany))])])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%",
      "border": "none !important",
      "padding-bottom": "0px !important"
    }
  })]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "25%",
      "text-align": "left !important",
      "border": "none !important",
      "padding-top": "0px"
    }
  }, [_c('span', [_c('label', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "2em !important",
      "padding-top": "10%",
      "padding-left": "12px"
    }
  }, [_c('strong', [_vm._v("[" + _vm._s(_vm.payMode) + "]")])])])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%",
      "border": "none !important",
      "padding-top": "0px"
    }
  }, [_c('center', [_c('barcode', {
    attrs: {
      "value": _vm.awbno,
      "format": "CODE128",
      "font-options": "bold",
      "width": "2",
      "height": "30"
    }
  })], 1)], 1), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%",
      "text-align": "right !important",
      "border": "none !important",
      "padding-top": "0px"
    }
  }, [_c('span', [_c('label', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "2em !important",
      "padding-top": "10%",
      "padding-right": "12px"
    }
  }, [_c('strong', [_vm._v("[" + _vm._s(_vm.routeDetails) + "]")])])])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "border-spacing": "0px !important",
      "font-size": "12px"
    },
    attrs: {
      "width": "100%",
      "border": "1"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%",
      "text-align": "left !important",
      "border": "none !important"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "left !important",
      "margin-left": "10px !important",
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Shipper : " + _vm._s(_vm.clientname))])])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%",
      "text-align": "right !important",
      "border": "none !important"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "right !important",
      "font-size": "15px",
      "margin-right": "10px !important"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('orders.orderNum')) + " : " + _vm._s(_vm.orderNo))])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "border-spacing": "0px !important"
    },
    attrs: {
      "width": "100%",
      "border": "2"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('th', {
    staticStyle: {
      "text-align": "Center !important",
      "font-size": "15px"
    },
    attrs: {
      "width": "50%"
    }
  }, [_c('strong', [_vm._v("Consignee Details")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "Center !important",
      "font-size": "15px"
    },
    attrs: {
      "width": "50%"
    }
  }, [_c('strong', [_vm._v("Order Details")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [(_vm.custname) ? _c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "border": "none !important",
      "width": "80%",
      "margin-left": "20px !important"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "left !important",
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.custname))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%",
      "border": "none !important",
      "text-align": "Center !important",
      "font-size": "15px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.custAddress) ? _c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "border": "none !important",
      "width": "80%",
      "margin-left": "20px !important"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "left !important",
      "width": "80%",
      "font-size": "15px",
      "text-align-last": "inherit"
    }
  }, [_vm._v(_vm._s(_vm.custAddress))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%",
      "border": "none !important",
      "text-align": "Center !important",
      "font-size": "15px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showpincode) ? _c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "border": "none !important",
      "width": "80%",
      "margin-left": "20px !important"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "left !important",
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.custstate) + "(" + _vm._s(_vm.custpincode) + ")")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%",
      "border": "none !important",
      "text-align": "Center !important",
      "font-size": "15px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.ismobileno) ? _c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "border": "none !important",
      "width": "80%",
      "margin-left": "20px !important"
    }
  }, [(_vm.mobileNo) ? _c('label', {
    staticStyle: {
      "text-align": "left !important",
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Mobile number:")]), _vm._v(" " + _vm._s(_vm.mobileNo)), _c('br')]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%",
      "border": "none !important",
      "text-align": "Center !important",
      "font-size": "15px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "border": "none !important",
      "width": "80%",
      "margin-left": "20px !important"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "left !important",
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("City :")]), _vm._v(" " + _vm._s(_vm.custcity))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%",
      "border": "none !important",
      "text-align": "Center !important",
      "font-size": "15px"
    }
  })]), _vm._v(" "), (_vm.payMode == 'COD') ? _c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "border": "none !important",
      "width": "80%",
      "margin-left": "20px !important"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "left !important",
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Collectable Amount :")]), _vm._v(" " + _vm._s(_vm.collectableamount))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "20%",
      "border": "none !important",
      "text-align": "Center !important",
      "font-size": "15px"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "40%",
      "border": "none !important",
      "margin-left": "20px !important"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "left !important",
      "font-size": "15px",
      "white-space": "nowrap"
    }
  }, [_c('strong', [_vm._v("Item Description :")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%",
      "border": "none !important",
      "text-align": "left !important",
      "font-size": "15px",
      "margin-left": "10px !important"
    }
  }, [_c('strong', {
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_vm._v(_vm._s(_vm.itemDesc))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "10%",
      "border": "none !important",
      "text-align": "Center !important",
      "font-size": "15px"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "border": "none !important",
      "margin-left": "20px !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "left !important",
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Quantity :")]), _vm._v(" " + _vm._s(_vm.quantity))])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "border": "none !important",
      "margin-left": "20px !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "left !important",
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Dimension : ")]), _c('span', [_vm._v(" " + _vm._s(_vm.dimention))])])])]), _vm._v(" "), (_vm.actWeight) ? _c('tr', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "border": "none !important",
      "margin-left": "20px !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "left !important",
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Actual Weight:")])]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.actWeight))])])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('td', {
    staticStyle: {
      "border": "none !important",
      "margin-left": "20px !important"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "left !important",
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Order Date :")]), _vm._v(" " + _vm._s(_vm.orderdate)), _c('br')])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "border-spacing": "0px !important"
    },
    attrs: {
      "width": "100%",
      "border": "1"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "background-color": "#ffff",
      "border": "none !important",
      "width": "100%"
    }
  }, [_c('label', {
    staticStyle: {
      "width": "100%",
      "text-align": "Center !important",
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("IF UNDELIVERED RETURN TO :")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#ffff",
      "border-bottom": "none !important",
      "margin-left": "20px !important"
    }
  }, [_c('label', {
    staticStyle: {
      "text-align": "Center !important",
      "font-size": "15px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.warehouseAdd) + "\n                ")])])])])])])])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f9419dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f9419dd","hasScoped":true}!./src/views/components/shippinglabel/shippinglabel.component.html
// module id = 1744
// module chunks = 0